import React from 'react'
import { useNavigate } from 'react-router-dom'
import crossClientLogo from '../../../assets/images/cross-client-logo.png'
import { Button } from '../../../components/Button/Button'
import './CrossClientQueryNotOwned.scss'

export const CrossClientQueryNotOwned: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className='d-flex flex-column align-items-center text-center zocks-gap-2 mt-2'>
      <img src={crossClientLogo} alt='' className='cross-client-logo-not-owned' />
      <div className='d-flex flex-column zocks-gap-0.5 align-items-center'>
        <h3>This query belongs to another user</h3>
        <div className='paragraph-large cross-client-not-owned-text-container'>You can only view your own queries. Open Client Queries to see yours.</div>
      </div>
      <Button variant='darkGhost' onClick={() => navigate('/cross-client')}>
        Back to Client Queries
      </Button>
    </div>
  )
}
